export const BASIC_MODE_ECOM_PLATFORM = 'SS_GENERIC_ECOM';
